import { IMockProps } from '_core/types';
import { ENDPOINT_API_PATH } from '../Definitions/MemberInfoDef';

const autoGenerateSuccess = () => {
  const validateSuccess: IMockProps = {
    doc: {
      code: 'Enviado com Sucesso',
      message: 'Enviado com Sucesso',
    },
    configRequest: {
      method: 'GET',
      path: ENDPOINT_API_PATH,
    },
    configResponse: {
      status: 200,
      data: {
        firstName: 'ÉRICK',
        lastName: 'SUGAHARA',
        status: 'ACTIVE',
        birthDate: '1995-05-08',
        memberTier: 'Smiles',
        milesBalance: '9719730',
        signatureClubStatus: 'ACTIVE',
        phoneDDINumber: '55',
        phoneDDDNumber: '19',
        phoneNumber: '997917371',
        verifiedPhoneNumber: 'N',
        email: 'erick.sugahara@softvaro.com.br',
        verifiedEmail: 'Y',
        partnerSourceAlias: '',
        partnerSourceName: '',
        channel: 'Web',
        memberNumber: '123432886',
        typeDocument: 'CPF',
        valueDocument: '18386017910',
      },
    },
  };
  return validateSuccess;
};

const generatedSuccessMocks = [autoGenerateSuccess()];

const MemberInfo = [...generatedSuccessMocks];
export default MemberInfo;
